import { IDirective, INgModelController } from 'angular';
import { isEmailValid } from '../../../helpers/validators';

export function gmcEmailValidatorDirective(): IDirective {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function postLink( scope, element, attrs, ngModel: INgModelController ) {
      if ( ngModel.$validators.email ) {
        ngModel.$validators.email = ( modelValue, viewValue ): boolean => {
          const value = modelValue || viewValue;
          return !value ? true : isEmailValid(value);
        };
      }
    }
  };
}



// WEBPACK FOOTER //
// ./app/shared/directives/validator-directives/gmc-email-validator.directive.ts